import { memo } from "react";
import AccountBoxIcon from '@mui/icons-material/AccountBox';
import {
    selectIsExportMerchantUsersLoading,
    selectIsExportMerchantsLoading
} from "features/merchants/selectors";
import { TableToolbar } from "ui/widgets/Table";
import AddEntity from "../../shared/AddEntity";
import type { MerchantUserToolbarProps } from "./types";
import BulkCreateUsers from "ui/organizms/Users/BulkCreateUsers";
import type { Option } from "types";

const Add = ({ fixedMerchant }: { fixedMerchant?: Option }) => (
    <>
        <AddEntity
            size='small'
            startIcon={<AccountBoxIcon />}
        >
            Add Merchant User
        </AddEntity>
        <BulkCreateUsers fixedMerchant={fixedMerchant} merchantRolesOnly />
    </>
);

const MerchantUserToolbar = ({ onExport, fixedMerchant, ...props }: MerchantUserToolbarProps) => (
    <TableToolbar
        {...props}
        onExport={onExport}
        selectIsExportLoading={state => (
            selectIsExportMerchantsLoading(state) ||
            selectIsExportMerchantUsersLoading(state)
        )}
        add={() => <Add fixedMerchant={fixedMerchant} />}
    />
);

export default memo(MerchantUserToolbar);
